import React from "react";
import CheckIconSmall from "@/shared/ui/icon/CheckIconSmall";
import { Link } from "@/i18n/navigation";

type PrivacyAgreementProps = {
  checked: boolean;
  toggleChecked: () => void;
  label: string;
  viewMoreLabel: string;
};

const DemoPrivacyAgreement = ({
  checked,
  toggleChecked,
  label,
  viewMoreLabel,
}: PrivacyAgreementProps) => {
  return (
    <div className="my-0 flex w-full animate-fade-in items-center gap-[8px] tablet:pl-[86px] main:my-[16px] main:gap-[12px] main:pl-[138px]">
      <button
        type="button"
        className={`${!checked ? "text-gray-300" : "text-primary"} cursor-pointer transition-all`}
        onClick={toggleChecked}
      >
        <CheckIconSmall />
      </button>
      <span className="font-[700] text-gray-800">
        <button
          type="button"
          className="cursor-pointer font-[700] text-gray-800"
          onClick={toggleChecked}
        >
          {label}
        </button>
        <Link
          target="_blank"
          href="/privacy/sensitive"
          className="font-[700] text-gray-800 underline"
        >
          {viewMoreLabel}
        </Link>
      </span>
    </div>
  );
};

export default DemoPrivacyAgreement;
